export default __webpack_public_path__ + "static/media/cameraOff.1e47dc51.svg";